import * as React from 'react';
import * as _ from 'lodash';
import {
    Container,
    Title,
    TitleChanged,
    FieldChanged,
    Field,
    Body,
    BodyText,
    ButtonContainer,
    MainContainer,
    ImageContainer,
    TextContainer
} from './styles';
import { RootState } from 'store/types';
import Modal from 'components/Modal';
import { ModalTitle } from 'common/styles';
import { ReactComponent as GMBCar } from 'common/images/car-gmb.svg'
import { ReactComponent as GMBCarGreen } from 'common/images/car-gmb-green-light.svg'
import { ReactComponent as GMBCarYellow } from 'common/images/car-gmb-yellow-light.svg'
import { ReactComponent as GMBCarRed} from 'common/images/car-gmb-red-light.svg'
import { ChangedInfoUI, ChangedListingInfoUI } from 'features/Dealers/Listings/state/types';

const TITLES: { [x: string]: string } = {
    ["push"]: "Push to GBP",
    ["success"]: "Success!",
    ["partial"]: "Data Partially Synced",
    ["notSynced"]: "Data Could Not Be Synced",   
    ["pushelite"] :"Update Business Details across the web" 
}

const BODIES: { [x: string]: string } = {
    ["push"]: "Are you sure you want to push your updated information to Google Business Profile?",
    ["success"]: "All of your data was synced with your GBP listing. You will be able to view updates live in your Google Business Profile soon.",
    ["partial"]: "There were issues syncing the following fields: Phone, Description, Menu URL, but your other data was properly synced.",
    ["notSynced"]: "There were issues syncing the following fields: Phone, Description, Appointment URL, Menu URL, Place Order Link, Date First Opened, Categories, Images, please solve these issues to be able to sync to GBP.",    
}


export interface ModalGenericProps {
    title?: string;
    body?: string;
    notice?: string | undefined;
    modal: string;
    errorMessage?: string
    listingsChanges?: ChangedInfoUI

    onKeyDown: (e) => void
    shouldShow: boolean
}


export class ModalGeneric extends React.Component<ModalGenericProps, {}> {

    constructor(props: ModalGenericProps) {
        super(props);
    }

    renderListingChanges = (changedListingInfo: ChangedListingInfoUI) => {
        return (
            <>
                <TitleChanged>
                {
                    changedListingInfo.departmentName
                }
                </TitleChanged>
                <FieldChanged>
                {
                    changedListingInfo.fieldsChanged.join(", ")
                }
                </FieldChanged>
            </>
        )
    }

    renderListingsChanges = () => {
        if (this.props.listingsChanges && this.props.listingsChanges.changedListingsInfo && this.props.listingsChanges.changedListingsInfo.length>0) {
            return (
                this.props.listingsChanges.changedListingsInfo.map((changedListingInfo) => {
                    return (
                        this.renderListingChanges(changedListingInfo)
                    )
                })
            )
        }
    }
    
    render() {
        return (
            <Modal shouldShow={this.props.shouldShow}>
                <Container onKeyDown={this.props.onKeyDown} shouldShow={this.props.shouldShow}>
                    <MainContainer>
                        <ImageContainer>
                            {
                                (this.props.modal === "push" || this.props.modal === "pushelite" ) && <GMBCar />
                            }
                            {
                                (this.props.modal === "success" || this.props.modal === "successelite" ) && <GMBCarGreen />
                            }
                            {
                                (this.props.modal === "partial" || this.props.modal === "partialelite"  ) && <GMBCarYellow />
                            }
                            {
                                (this.props.modal === "notSynced" || this.props.modal === "notSyncedelite" ) && <GMBCarRed />
                            }
                        </ImageContainer>
                        
                        <TextContainer>
                            {
                                <ModalTitle>
                                    {
                                        TITLES[this.props.modal]
                                    }
                                </ModalTitle>
                            }
                            <Body>
                                <BodyText>
                                    {
                                        this.props.modal === "push" && "Are you sure you want to push your updated information to Google Business Profile?"
                                    }
                                    {
                                        this.props.modal === "pushelite" && "Are you sure you want to push your updated information to all of the listing and citation sites associated with your business?"
                                    }
                                    {
                                        (this.props.modal === "push" || this.props.modal === "pushelite") && this.renderListingsChanges()
                                    }
                                    {
                                        this.props.modal === "success" && "All of your data was synced with your GBP listing. You will be able to view updates live in your Google Business Profile soon."
                                    }
                                    {
                                        this.props.modal === "successelite" && "All of your data was successfully sent to the listing and citation sites associated with your business and Listings Manager. Please allow at least 24 hours for the changes to be reflected in the individial platforms"
                                    }
                                    {
                                        this.props.modal === "partial" && 
                                        <label> 
                                            {'There were issues syncing the following fields: '} 
                                            {
                                                this.props.errorMessage?.split(',').map(field => {
                                                    return(
                                                        <label> 
                                                            <Field> {field} </Field> {', '}
                                                        </label>
                                                    );
                                                })
                                            }
                                            {'but your other data was properly synced.'} 
                                        </label>
                                    }
                                    {
                                        this.props.modal === "notSynced" && 
                                        <label> 
                                            { this.props.errorMessage + " Please solve these issues to be able to sync to GBP."} 
                                        </label>
                                    }
                                    {
                                        this.props.modal === "notSyncedelite" && 
                                        <label> 
                                            {'There were issues syncing the following fields: '} 
                                            {
                                                this.props.errorMessage?.split(',').map(field => {
                                                    return(
                                                        <label> 
                                                            <Field> {field} </Field> {', '}
                                                        </label>
                                                    );
                                                })
                                            }

                                            { "Please solve these issues to be able to update your business details across the web."} 
                                        </label>
                                    }
                                </BodyText>
                            </Body>
                        </TextContainer>
                    </MainContainer>
                    
                    
                    <ButtonContainer>
                        {
                            this.props.children
                        }
                    </ButtonContainer>
                </Container>
            </Modal>
        );
    }
}
